// import style
import "../../style/pages/thanks/thanks.scss";

const Thanks = () => {
  return (
    <section className="container thank-you-section">
      <main className="thank-you-main">
        <div className="thank-you-content">
          <p className="thank-you-heading">
            Thank you for reaching out! We’ll get back to you as soon as
            possible.
          </p>
          <p className="thank-you-subheading">
            お問い合わせいただきありがとうございます。できるだけ早くご連絡いたします。
          </p>
        </div>
      </main>
    </section>
  );
};

export default Thanks;
